<template>
  <div id="whoops" class="whoops-wrapper">
    <div class="cx-div -center">
      <router-link-localed class="theme-logo"
        :to="{name: `Home_${$i18n.locale}`}"
      >
        <div class="theme-logo__img m-header__govlogo"></div><div class="theme-logo__img m-header__logo"></div>
      </router-link-localed>
    </div>
    <cx-img 
      tag='i'
      class="m-graphic--404 cx-div"
      imgSrc="/static/graphic/mgto_graphic_404.png"
    ></cx-img>
    <h1 class="cx-t20"
    >{{getText('pageError', 'pageError')}}</h1>
    <p v-if="$te('home.home')">
      <router-link :to="'/'">
        <i class="far fa-home"></i>
        {{getText('home', 'home')}}
      </router-link>
    </p>
  </div>
</template>

<script>
import { PAGE_LOADED } from '../constants/gtmce';

export default {
  name: 'whoops-view',
  created() {
    if (this.$ssrContext) {
      const title = this.getText('pageError', 'header')
      this.$ssrContext.title = title 
        ? `${title} - ${this.getText('footer', 'contactOffice')}`
        : this.getText('footer', 'contactOffice');
    }
  },
  mounted() {
    const title = this.getText('pageError', 'header')
    document.title = title 
      ? `${title} - ${this.getText('footer', 'contactOffice')}`
      : this.getText('footer', 'contactOffice');

    console.log('[HEADER UPDATED]', document.title);
    setTimeout(() => this.$gtmPush(PAGE_LOADED), 0);
  },
  uit() {
    return [
      ['home', ['home']],
      ['pageError', ['header', 'pageError']]
    ]
  },
  data() {
    return {
      fallbackLang: {
        'en': {
          'home': {
            'home': 'Home',
          },
          'pageError': {
            'header': '500: Internal Server Error',
            'pageError': 'Whoops! Something went wrong on this page.',
          },
          'footer': {
            'contactOffice': 'Macao Government Tourism Office'
          }
        },
        'zh-hant': {
          "home": {
            "home": "主頁"
          },
          "pageError": {
            "header": "500：伺服器錯誤",
            "pageError": "此頁面可能正在維護中，請稍後再回來。"
          },
          "footer": {
            "contactOffice": "澳門特別行政區政府旅遊局"
          }
        },
        'zh-hans': {
          "home": {
            "home": "主页"
          },
          "pageError": {
            "header": "500：服务器错误",
            "pageError": "此页面可能正在维护中，请稍后再回来。"
          },
          "footer": {
            "contactOffice": "澳门特别行政区政府旅游局"
          }
        },
        'pt': {
          "home": {
            "home": "Home"
          },
          "pageError": {
            "header": "",
            "pageError": ""
          },
          "footer": {
            "contactOffice": "Direcção dos Serviços de Turismo"
          }
        },
        'ja': {
          "home": {
            "home": "ホーム"
          },
          "pageError": {
            "header": "500: インターネットサーバーエラー",
            "pageError": "このページはメンテナンス中の可能性があります。後ほどご確認ください。"
          },
          "footer": {
            "contactOffice": "マカオ政府観光局"
          }
        },
        'ko': {
          "home": {
            "home": "홈"
          },
          "pageError": {
            "header": "내부 서버 오류",
            "pageError": "이 페이지는 현재 보수중이니 다음에 다시 방문해 주시기 바랍니다."
          },
          "footer": {
            "contactOffice": "마카오정부관광청"
          }
        },
        'th': {
          "home": {
            "home": "หน้าหลัก"
          },
          "pageError": {
            "header": "500: เกิดข้อผิดพลาดทางระบบอินเทอร์เน็ต",
            "pageError": "หน้าเว็ปนี้อาจไม่ได้รับการปรับปรุง กรุณากลับเข้ามาภายหลัง"
          },
          "footer": {
            "contactOffice": "สำนักงานการท่องเที่ยวของรัฐบาลมาเก๊า"
          }
        },
        'ms': {
          "home": {
            "home": "Halaman Utama"
          },
          "pageError": {
            "header": "500: Ralat Pelayan Dalaman",
            "pageError": "Ops! Muka web ini mungkin dalam penyelenggaraan. Sila kembali kemudian."
          },
          "footer": {
            "contactOffice": "Pejabat Pelancongan Kerajaan Macao"
          }
        },
        'id': {
          "home": {
            "home": "Beranda"
          },
          "pageError": {
            "header": "500: Internal Server Error",
            "pageError": "Whoops! Halaman ini mungkin sedang dalam perbaikan. Harap kembali lagi nanti."
          },
          "footer": {
            "contactOffice": "Kantor Pariwisata Pemerintah Macau"
          }
        },
        'de': {
          "home": {
            "home": "Startseite"
          },
          "pageError": {
            "header": "500: Interne Serverfehler",
            "pageError": "Whoops! Diese Seite ist zurzeit in der Wartung. Bitte besuchen Sie später."
          },
          "footer": {
            "contactOffice": "Fremdenverkehrsbüro Macau"
          }
        },
        'fr': {
          "home": {
            "home": "Accueil"
          },
          "pageError": {
            "header": "500-Erreur interne du serveur",
            "pageError": "Page en cours de maintenance. Réessayez plus tard."
          },
          "footer": {
            "contactOffice": "Office du Tourisme de Macao"
          }
        },
        'es': {
          "home": {
            "home": "Inicio "
          },
          "pageError": {
            "header": "",
            "pageError": ""
          },
          "footer": {
            "contactOffice": "Oficina de Turismo del Gobierno de Macao"
          }
        },
        'it': {
          "home": {
            "home": "Home"
          },
          "pageError": {
            "header": "",
            "pageError": ""
          },
          "footer": {
            "contactOffice": "Ufficio del turismo del governo di Macao"
          }
        },
        'ru': {
          "home": {
            "home": "Главная"
          },
          "pageError": {
            "header": "500: внутренняя ошибка сервера",
            "pageError": "Упс! Эта страница обновляется. Пожалуйста, возращайтесь позднее."
          },
          "footer": {
            "contactOffice": "Управление по туризму Правительства Макао"
          }
        },
        'ar': {
          "home": {
            "home": "الصفحة الرئيسية"
          },
          "pageError": {
            "header": "",
            "pageError": ""
          },
          "footer": {
            "contactOffice": "مكتب السياحة الحكومي في ماكاو"
          }
        }
      }
    }
  },
  methods: {
    getText: function(group, key) {
      let i18nKey = `${group}.${key}`;
      if (this.$te(i18nKey)) return this.$t(i18nKey);
      
      let locale = this.fallbackLang[this.$i18n.locale] ? this.$i18n.locale : 'en';
      return this.fallbackLang[locale][group][key];
    }
  }
}
</script>

<style lang="scss">
.whoops-wrapper{
  text-align: center;
  padding: 15vh $space-base;
  word-break: break-all;
  max-width: 1000px;
  margin: auto;

  .cx-t20{
    word-break: normal !important;
  }
}
</style>
